<p id="title">Terms of Service</p>

<span style="font-size: 12px"
  >Last Updated: {{ ctimeDate(systemStatus.updated_at) }} <br />Version:
  {{ systemStatus.version }}</span
>
<br /><br />
<!-- Welcome to markadoc web service! <br> -->
<p>
  <span id="number-indent"> </span>
  By using our Services, you agree to be bound by these Terms. If you don’t
  agree to these Terms, do not use the Services. If you are accessing and using
  the Services on behalf of a company (such as your employer) or other legal
  entity, you represent and warrant that you have the authority to bind that
  company or other legal entity to these Terms. In that case, “you” and “your”
  will refer to that company or other legal entity.
</p>
<p>
  <span id="number-indent">1. </span>
  markadoc is a software as a service (SaaS) application provided on multiple
  platforms including web browser, Android and Apple ios platforms which will be
  hereinafter referred to as this/the “Program” or “Application” or “Service”
</p>
<p>
  <span id="number-indent">2. </span>
  On payment of the monthly subscription you (the user) are granted a right to
  use this Program for a limited period of time as specified in the subscription
  term. Said right does not constitute ownership or licensing of the actual
  Application software or source code.
</p>
<p>
  <span id="number-indent">3. </span>
  You the user/subscriber will inform yourself of the minimum hardware and
  software requirements before paying for a subscription for a right to use the
  Application.
</p>
<p>
  <span id="number-indent">4. </span>
  You the user/subscriber will not and may not attempt to reverse engineer the
  program or provide the program to any third party for reverse engineering of
  program code.
</p>
<p>
  <span id="number-indent">5. </span>
  This Program, Application and Service is provided on an "as is" basis and
  though reasonable effort will be made to ensure it is free of defects and
  generally available for use no warranty is provided or implied regarding the
  use of the Program/Application/Service or the accuracy of information
  presented by the program.
</p>
<p>
  <span id="number-indent">6. </span>
  This Program/Service comes with no warranty or terms of availability.
  Availability of current and future versions of the program or program updates
  will be provided at the sole discretion of the program author and are not
  guaranteed.
</p>
<p>
  <span id="number-indent">7. </span>
  You the user/subscriber indemnify and protect the program author from any
  actions or consequences for you the subscriber users use or misuse of this
  program and you will not hold the Program, Application, or Service author
  liable for any use or misuse of the Program, Application, Service.
</p>
<p>
  <span id="number-indent">8. </span>
  You agree to be responsible for any and all legal fees for you the
  user/subscriber and the program author should you take any legal action
  against the program author.
</p>
<p>
  <span id="number-indent">9. </span>
  Any and all legal action should they be initiated will be subject to the laws
  and courts of the State of New York.
</p>
<p>
  <span id="number-indent">10. </span> This Program, Application, Service is
  authored and Copyright (c) 2019, 2021 by Markadoc Corporation of New York with
  all rights reserved and Patent Pending and by subscribing to use the Program
  you acknowledge said copyrights.
</p>
<p>
  <span id="number-indent">11. </span>
  By clicking on the "I Accept Terms" button you the subscriber and program user
  agree to and will abide by these terms of use.
</p>
<p id="last-section">
  <span id="number-indent">12. </span>
  Any and all subscription payments made for use of the Program, Application,
  Service are non-refundable unless otherwise noted in the payment subscription
  terms.
</p>
